import { takeEvery, call, put } from 'redux-saga/effects';
import { apiPost } from '../core/dapi';
import { getFoundHelpfulUrl } from '../core/dapi/solvRatings';
import { helpfulCountUpdating, helpfulCountUpdated, helpfulCountError } from '../ducks/solvRatings';

const INCREMENT_HELPFUL_COUNT = 'saga/INCREMENT_HELPFUL_COUNT';

function* incrementHelpfulCount({ solvRatingId }) {
  try {
    yield put(helpfulCountUpdating(solvRatingId, true));
    const foundHelpfulUrl = getFoundHelpfulUrl(solvRatingId);

    const updatedSolvRating = yield call(apiPost, foundHelpfulUrl, {});
    yield put(helpfulCountUpdated(solvRatingId, updatedSolvRating.helpful_count));
  } catch (e) {
    yield put(helpfulCountError(solvRatingId, e.message));
  } finally {
    yield put(helpfulCountUpdating(solvRatingId, false));
  }
}

function* rootSaga() {
  yield takeEvery(INCREMENT_HELPFUL_COUNT, incrementHelpfulCount);
}

export { INCREMENT_HELPFUL_COUNT, rootSaga as default };
